import { TextInput } from 'react-admin';
import FileManagerModalInput from '../FileManagerModalInput';
import TinyMCEInput from '../TinyMCEInput';
import ArrayForm from './ArrayForm';
import BoundedInput from './BoundedInput';

const ArrayInnerSensations = ({ index, source }: { source: string, index: number }) => {
    return (
        <ArrayForm source={source} grid={0} simpleFormIteratorProps={{
            sx: {
                '& .RaSimpleFormIterator-form': {
                    display: 'grid',
                    gap: '0px',
                    columnGap: '10px',
                    gridTemplateAreas: `
'order_no order_no order_no'
'image image image'
'author_en author_tc author_sc'
'description_en description_en description_en'
'description_tc description_tc description_tc'
'description_sc description_sc description_sc'
`
                }
            }
        }}>
            {/* <Grid container spacing={1} columnSpacing={1}> */}
            <BoundedInput source={`order_no`} input={<TextInput source="dummy" />} />
            <BoundedInput source={`image`} input={<FileManagerModalInput source="dummy" />} />
            <BoundedInput source={`author_en`} label="Author EN" input={<TextInput source="dummy" />} />
            <BoundedInput source={`author_tc`} label="Author TC" input={<TextInput source="dummy" />} />
            <BoundedInput source={`author_sc`} label="Author SC" input={<TextInput source="dummy" />} />
            <BoundedInput source={`description_en`} label="Description EN" input={<TinyMCEInput source="dummy" />} />
            <BoundedInput source={`description_tc`} label="Description TC" input={<TinyMCEInput source="dummy" />} />
            <BoundedInput source={`description_sc`} label="Description SC" input={<TinyMCEInput source="dummy" />} />
        </ArrayForm>
    )
}

export default ArrayInnerSensations;